// removed by extract-text-webpack-plugin
module.exports = {"main":"_1ZMGa7Obkf8PQalTULYTzw"};